<template>
    <div>
      <solution-header
        :actIndex="actIndex"
        :imgList="imgList"
        :topStyle="topStyle"
        :logo="logo"
        :productType="productType"
        :titleObj="titleObj"
        :actId="solutionId"
      >
      </solution-header>
      
      <div class="box">
        <div class="hide-box"></div>
        <img class="v_html_img" :src="img" alt="">
      </div>
      <address class="medicine-footer clearfix">
        <h3>让营销从此变得多姿多彩，现在咨询更多优惠!</h3>
        <div @click="jumpService">立即咨询</div>
      </address>
      <solution-footer
        :bottom="bottom"
        :bottomInfo="bottomInfo"
        :bottomNews="bottomNews"
        :productType="productType"
      ></solution-footer>
    </div>
  </template>
  
<script>
  import solutionHeader from "@/components/mobile/Header";
  import solutionFooter from "@/components/mobile/Footer";
  export default {
    name: "m_solutionProramme",
    data() {
      return {
        solutionData: "",
        solutionType: "",
        topStyle: "",
        actIndex: 3,
        imgList: [],
        logo: "",
        productType: [],
        bottom: {},
        bottomInfo: {},
        bottomNews: [],
        titleObj: {},
        solutionId: '',
        img:'',
      };
    },
    created() {
      this.solutionId = this.$route.params.type;
    },
    mounted() {
      this.solutionId = this.$route.params.type;
      // console.log(this.$route.params.type)
      this.Pc_Mobile();
      this.getPageData();
      this.getSolutionData();
    },
    methods: {
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      Pc_Mobile() {
        if (this._isMobile()) {
          this.$router.push("/m_solutionProramme/" + this.$route.params.type);
        } else {
          this.$router.push("/solution/mother");
        }
      },
      getSolutionData() {
        // this.$http.post(
        //   "https://eartisanapplets.wsandos.com/api/index/productdetail",
        //   { id: this.$route.params.type },
        //   (res) => {
        //     // console.log(res.data)
        //     if (res.code == 1) {
        //       this.solutionData = res.data.content;
        //       this.topStyle = "background-image:url('" + res.data.image + "')";
        //       this.titleObj = {
        //         title: res.data.title,
        //         desc: res.data.desc,
        //       };
        //     }
        //   }
        // );
        this.$http.get(
        "https://eartisanapplets.wsandos.com/api/industry_case/CaseList",
        null,
        (res) => {
          const idd = this.$route.params.type;
          if(idd){
            const name = res.data.title_list.title;
            const sub_name = res.data.title_list.sub_title;
            const result = res.data.case_list;
            const arr = result.filter(item => item.id == idd);
            if(!arr) return;
            const data  = arr[0];
              this.topStyle = "background-image:url('"+require('../../static/images/programme/banner1.png')+"')";
              this.titleObj = {
                title: name,
                desc: sub_name,
              };
              this.img = data.mobile_image;
              // console.log(data);
          }
        }
      );
      },
  
      getPageData() {
        this.$http.post("home/index/product", null, (res) => {
          // console.log(res.data)
          this.bottom = res.data.bottom[0];
          this.logo = this.bottom.logo;
          this.bottomInfo = res.data.contact[0];
          this.productType = res.data.type;
          this.productAll = res.data.product;
          this.bottomNews = res.data.b_news;
        });
      },
  
      jumpService() {
        this.$addConsult()
      }
    },
    components: {
      solutionHeader,
  
      solutionFooter,
    },
  };
  </script>
  
<style lang="stylus" scoped>
  .box{
    position:relative;
  }
  .hide-box{
    position: absolute;
    top:0;
    left:0;
    width:100%;
    height: 100%;
  }
  .v_html_img{
    display: block;
    max-width 100%;
    height auto;
    // margin:0px auto;
    // padding:0 10px;
    box-sizing: border-box;
    pointer-event:none;
    -webkit-user-select:none;
    -moz-user-select:none;
    user-select:none;
  }
.medicine-footer {
  width: 100%;
  height: 130px;
  background: url('../../static/images/fiveG/bg(1).png');
  text-align: center;
  border-sizing: border-box;
  position: relative;
  z-index: 3;

  h3 {
    padding-top: 20px;
    font-size: 17px;
    line-height: 28px;
    color: #FFFFFF;
  }

  div {
    text-decoration: none;
    display: inline-block;
    width: 100px;
    height: 35px;
    margin: 15px auto;
    font-size: 14px;
    font-weight: bold;
    color: #FFFEFC;
    line-height: 35px;
    border: 1px solid #FFFEFC;
    border-radius: 30px;
    box-sizing: border-box;
  }
}

</style>


// WEBPACK FOOTER //
// src/views/mobile/solutionProramme.vue